import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="mx-auto flex min-h-[70vh] max-w-xl flex-col items-center justify-center px-5 text-center" data-testid="payment-cancel-page">
      <h1 className="font-display text-5xl tracking-tight">Payment cancelled.</h1>
      <p className="mt-4 text-[var(--ink-soft)]">No charge was made. Your bag is saved whenever you're ready.</p>
      <Link to="/checkout" className="mt-10 rounded-full bg-[var(--ink)] px-8 py-4 text-sm font-semibold text-[var(--bone)]" data-testid="cancel-back-to-checkout">Return to checkout</Link>
    </div>
  );
}
